import { render, staticRenderFns } from "./TeamAttendanceCorrectionsMain.vue?vue&type=template&id=4a4a59d4"
import script from "./TeamAttendanceCorrectionsMain.vue?vue&type=script&lang=js"
export * from "./TeamAttendanceCorrectionsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports